import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18v-6a3 3 0 0 1 3 -3h7","key":"svg-0"}],["path",{"d":"M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4","key":"svg-1"}]]

const IconCornerUpRightDouble = createReactComponent('outline', 'corner-up-right-double', 'CornerUpRightDouble', __iconNode);

export default IconCornerUpRightDouble;